var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maps"},[_vm._v("\n  WORK IN PROGRESS - KNOWN ISSUES USING WEBPACK AND LEAFLET"),_c('br')])
}]

export { render, staticRenderFns }